import { UrlTls } from './UrlTls';
import Router from '../../router';
const PoleTls = {
    getInfo(poleRow) {
        let info = '';
        info += '<b>' + poleRow.height + "/" + poleRow.weight + '</b><br/>';
        if (poleRow.codition) info += poleRow.codition + '<br>';
        info += "Feeder ID: " + poleRow.feeder_id;
        info += '<br/><a target="_blank" href="#/simple-edit/poles/_id/' + poleRow._id + '" >اطلاعات</a> ';
        info += '<br/><a target="_blank" href="#/simple-edit-d/poles/_id/' + poleRow._id + '" >شماره پایه</a> ';

        
        var feederNewId = Router.currentRoute._rawValue.params.feederId;

        info += '<br><a href="' + UrlTls.getBaseUrl() + '/poles/add-feeder/' + poleRow._id +'/'+feederNewId+ '">افزودن فیدر</a>';
        info += '<a href="' + UrlTls.getBaseUrl() + '/poles/remove-feeder/' + poleRow._id +'/'+feederNewId +'">حذف فیدر</a>';


        info += '<form action="'+UrlTls.getBaseUrl()+'/free/poles/_id/'+poleRow._id+'" target="_blank"  method="POST"><input name="pole_num" value="'+poleRow.pole_num+'"/></form>';

     
        return info;

    },
    sumBranches(poleArr) {
        var res = {
            n_branch_1ph: 0,
            n_branch_3ph: 0,
            l_branch: 0,
            n_branch_light: 0,
            n_branch_con: 0
        };
        if(!poleArr) return res;
        for (var i = 0; i < poleArr.length; i++) {
            
            res.n_branch_1ph+=eval(poleArr[i]['n_branch_1ph']);
            res.n_branch_3ph+=eval(poleArr[i]['n_branch_3ph']);
            res.l_branch+=eval(poleArr[i]['l_branch']);
            res.n_branch_light+=eval(poleArr[i]['n_branch_light']);
            res.n_branch_con+=eval(poleArr[i]['n_branch_con']);
     
        }
        return res
    }
}


export {
    PoleTls
}
